<template>
  <div id="pxcom-logo">
    <a v-if="hasLink" :href="link">
      <img alt="PXCom" src="../../assets/img/logo_pxcom.png" />
    </a>
    <img v-if="!hasLink" alt="PXCom" src="../../assets/img/logo_pxcom.png" />
  </div>
</template>

<script>
export default {
  name: 'px-logo',
  props: ['link'],
  computed: {
    hasLink () {
      return this.link && this.link.startsWith('http')
    }
  }
}
</script>
